// Colors
// import logo from "assets/images/logo_dark.svg";

import { shade, tint } from "tint-shade-color";

const neutral = {
	100: "#F3F4F6",
	200: "#E5E7EB",
	300: "#D1D5DB",
	400: "#9CA3AF",
	500: "#6B7280",
	600: "#4B5563",
	700: "#374151",
	800: "#1F2937",
	900: "#111827",
};

// const background = {
//   default: '#0B0F19',
//   paper: neutral[900]
// };

const background = {
	default: "#1E1E1E",
	paper: "#292929",
	gray: "#555555",
	darkGray: "#333333",
	border: tint("#949494", 0.7),
	dark: "#CCCCCC",
	disabled: "rgba(255, 255, 255, 0.12)", 
};

const sideMenu = {
	background: "#211D1C",
	divider: neutral["800"],
	text: background.paper,
};

const divider = "#2D3748";

const colorAccent = "#F47C06";

const primary = {
	main: colorAccent,
	light: tint(colorAccent, 0.3),
	dark: shade(colorAccent, 0.2),
	shade: "#FA9579",
	contrastText: "#FFFFFF",
  	darkText: "#FFFFFF"
};

const secondary = {
	main: "#F47C06",
	light: "#BBDEFB",
	dark: "#0B815A",
	contrastText: "#FFFFFF",
};

const success = {
	main: "#4caf50",
	light: "#81c784",
	dark: "#388e3c",
	shade: "#CCF0D4",
	contrastText: "#FFFFFF",
};

const info = {
	main: "#F47C06",
	light: "#64B6F7",
	dark: "#F47C06",
	contrastText: "#FFFFFF",
};

const warning = {
	main: "#ff9800",
	light: "#ffb74d",
	dark: "#f57c00",
	shade: "#FBF2E5",
	secondary: "#F9AA38",
	contrastText: "#FFFFFF",
};

const error = {
	main: "#f44336",
	light: "#e57373",
	dark: "#d32f2f",
	shade: "#FDE8E8",
	contrastText: "#FFFFFF",
};

const text = {
	// primary: "#111827",
	primary: '#EDF2F7',
	secondary: "#A0AEC0",
	// secondary: '#6B7280',
	disabled: "rgba(255, 255, 255, 0.48)",
	contrastText: '#FFFFFF'
};

// const text = {
//   primary: '#111827',
//   active: "#F47C06",
//   secondary: '#6B7280',
//   grayLight: "#B7B7B7",
//   grayDark: "#5E5F62",
//   disabled: 'rgba(55, 65, 81, 0.48)',
//   white: "#fff",
//   black: "#000",
//   contrastText: '#FFFFFF'
// };

const darkThemeOptions = {
	// assets: {logo},
	components: {
		MuiAvatar: {
			styleOverrides: {
				root: {
					backgroundColor: neutral[500],
					color: "#FFFFFF",
				},
			},
		},
		MuiChip: {
			styleOverrides: {
				root: {
					"&.MuiChip-filledDefault": {
						backgroundColor: neutral[800],
						"& .MuiChip-deleteIcon": {
							color: neutral[500],
						},
					},
					"&.MuiChip-outlinedDefault": {
						borderColor: neutral[700],
						"& .MuiChip-deleteIcon": {
							color: neutral[700],
						},
					},
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				input: {
					"&::placeholder": {
						opacity: 1,
						color: text.secondary,
					},
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				notchedOutline: {
					borderColor: divider,
				},
			},
		},
		MuiMenu: {
			styleOverrides: {
				paper: {
					borderColor: divider,
					borderStyle: "solid",
					borderWidth: 1,
				},
			},
		},
		MuiPopover: {
			styleOverrides: {
				paper: {
					borderColor: divider,
					borderStyle: "solid",
					borderWidth: 1,
				},
			},
		},
		MuiSwitch: {
			styleOverrides: {
				switchBase: {
					color: neutral[700],
				},
				track: {
					backgroundColor: neutral[500],
					opacity: 1,
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				root: {
					borderBottom: `1px solid ${divider}`,
				},
			},
		},
		MuiTableHead: {
			styleOverrides: {
				root: {
					backgroundColor: neutral[800],
					".MuiTableCell-root": {
						color: neutral[300],
					},
				},
			},
		},
	},
	palette: {
		action: {
			active: neutral[400],
			hover: "rgba(255, 255, 255, 0.04)",
			selected: "rgba(255, 255, 255, 0.08)",
			disabledBackground: "rgba(255, 255, 255, 0.12)",
			disabled: "rgba(255, 255, 255, 0.26)",
		},
		background,
		divider,
		error,
		info,
		mode: "dark",
		neutral,
		primary,
		secondary,
		success,
		text,
		warning,
		sideMenu,
		colorAccent,
	},
	shadows: [
		"none",
		"0px 1px 2px rgba(0, 0, 0, 0.24)",
		"0px 1px 2px rgba(0, 0, 0, 0.24)",
		"0px 1px 4px rgba(0, 0, 0, 0.24)",
		"0px 1px 5px rgba(0, 0, 0, 0.24)",
		"0px 1px 6px rgba(0, 0, 0, 0.24)",
		"0px 2px 6px rgba(0, 0, 0, 0.24)",
		"0px 3px 6px rgba(0, 0, 0, 0.24)",
		"0px 4px 6px rgba(0, 0, 0, 0.24)",
		"0px 5px 12px rgba(0, 0, 0, 0.24)",
		"0px 5px 14px rgba(0, 0, 0, 0.24)",
		"0px 5px 15px rgba(0, 0, 0, 0.24)",
		"0px 6px 15px rgba(0, 0, 0, 0.24)",
		"0px 7px 15px rgba(0, 0, 0, 0.24)",
		"0px 8px 15px rgba(0, 0, 0, 0.24)",
		"0px 9px 15px rgba(0, 0, 0, 0.24)",
		"0px 10px 15px rgba(0, 0, 0, 0.24)",
		"0px 12px 22px -8px rgba(0, 0, 0, 0.24)",
		"0px 13px 22px -8px rgba(0, 0, 0, 0.24)",
		"0px 14px 24px -8px rgba(0, 0, 0, 0.24)",
		"0px 20px 25px rgba(0, 0, 0, 0.24)",
		"0px 25px 50px rgba(0, 0, 0, 0.24)",
		"0px 25px 50px rgba(0, 0, 0, 0.24)",
		"0px 25px 50px rgba(0, 0, 0, 0.24)",
		"0px 25px 50px rgba(0, 0, 0, 0.24)",
	],
};

export default darkThemeOptions;
